export default [
    {
        path: '/personal/index',
        name: '个人中心',
        component: function (resolve) {
            require(['@/pages/userPage/personal/index'],resolve)
        }
    },
    {
        path: '/shoppingMall/preview',
        name: 'shoppingMallPreview',
        component: function (resolve) {
            require(['@/pages/userPage/shoppingMall/preview'], resolve)
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/user.js